/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

// import { SOUND, Image_3D } from "../../assets/images";
export const DATA = {
    "getAsset": {
    "title": "Paalangal by Sivasankari",
    "subtitle": "<p>&nbsp;</p>\n\n<p>About the story:</p>\n\n<p>This story travels through three different generations and how the culture, and habits of people have changed over time, from the girl&#39;s point of view.</p>\n\n<p>&nbsp;</p>\n\n<p>About the author:</p>\n\n<p>Sivasankari&nbsp;is a renowned Tamil writer and activist. She has carved a niche for herself in the Tamil literary world during the last four decades with her works that reflect an awareness on social issues, a special sensitivity to social problems, and a commitment to set people thinking. She has many novels, novellas, short stories, travelogues, articles and biographies to her credit. Her works have been translated into several Indian languages, English, Japanese and Ukrainian. Eight of her novels have been made into films, having directed by renowned directors like K. Balachander, SP Muthuraman and Mahendran. Her novel &#39;Kutti&#39; on girl child labour, filmed by the director Janaki Viswanathan, won the President&#39;s Award. Sivasankari&#39;s novels have also been made as teleserials, and have won the national as well as regional &#39;Best Mega Serial&#39; awards. As a multi-faceted personality, she has won many prestigious awards including Kasturi Srinivasan Award, Raja Sir Annamalai Chettiyar Award, Bharatiya Bhasha Parishad Award, &#39;Woman of the year 1999-2000&#39; by the International Women&#39;s Association, and so on. &#39;Knit India Through Literature&#39; is her mega-project involving intense sourcing, research and translations of literature from 18 Indian languages, with a mission to introduce Indians to other Indians through culture and literature.</p>",
    "serialNo": "809",
    "tokenGroup": "uD8sZ",
    "tag": "gold",
    "likes": 0,
    "img": "https://unec.edu.az/application/uploads/2014/12/pdf-sample.pdf",
    "thumbnail": "https://assetgateway.vantr.io/ipfs/Qmc2XMoTokoUyXe9FtzDhBXZ9guTvVKFMUdN4wd27anReg",
    "category": "entertainment",
    "type": "doc",
    "price": [
        {
            "type": "crypto",
            "amount": 153,
            "currency": "MATIC",
            "sale": {
                "salePrice": null,
                "saleEndDate": null
            },
            "symbol": "S",
            "resell": false
        }
    ],
    "symbol": null,
    "attrs": [
        {
            "name": "Author",
            "val": "Sivasankari",
            "disp_type": "string",
            "disp_val": null
        },
        {
            "name": "Privilege 1",
            "val": "Signed Copy of Book",
            "disp_type": "string",
            "disp_val": null
        },
        {
            "name": "Privilege 2",
            "val": "Video Interaction with Author",
            "disp_type": "string",
            "disp_val": null
        }
    ],
    "media": [],
    "digitalTwin": "Yes",
    "nftProvenance": [
        {
            "title": "Listed By",
            "from": {
                "name": "FirstZodiac",
                "address": "0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed",
                "link": "/ firstzodiac ",
                "authProofUrl": "https://mumbai.polygonscan.com/address/0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed "
            },
            "to": null,
            "tx_proof": null,
            "date": "Tue, Aug 9, 2022 3:22 AM GMT",
            "meta": {
                "store": "Vantr Marketplace"
            }
        },
        {
            "title": "Created By",
            "from": {
                "name": "FirstZodiac",
                "address": "0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed",
                "link": "/ firstzodiac ",
                "authProofUrl": "https://mumbai.polygonscan.com/address/0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed "
            },
            "to": null,
            "tx_proof": null,
            "date": "Tue, Aug 9, 2022 3:22 AM GMT",
            "meta": null
        }
    ],
    "networkType": "polygon",
    "chainId": "137",
    "hasProvenance": false,
    "creator": {
        "name": "FirstZodiac",
        "link": "/ firstzodiac ",
        "address": "0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed",
        "authProofUrl": "https://mumbai.polygonscan.com/address/0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed ",
        "email": "first.zodiac.sign@gmail.com"
    },
    "owner": {
        "name": "FirstZodiac",
        "link": "/ firstzodiac ",
        "address": "0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed",
        "authProofUrl": "https://mumbai.polygonscan.com/address/0x7053099e6e8eeb8edc6f80829c1f78369b27f9ed ",
        "email": "first.zodiac.sign@gmail.com"
    },
    "claimEnabled": false,
    "tx_proof": "",
    "toBeClaimedBy": {
        "claimType": null
    }
},
    "viewInIpfs": "https://assetgateway.vantr.io/ipfs/Qmc2XMoTokoUyXe9FtzDhBXZ9guTvVKFMUdN4wd27anReg"
}




export const DETAIL_DATA = [
    {
        "getAsset": {
            "title": "PDF DUMMY TEST",
            "subtitle": "<p>testing pdf asset from test data</p>",
            "serialNo": "1219",
            "tokenGroup": "uD8sZ",
            "tag": "platinum",
            "likes": 0,
            "img": "https://unec.edu.az/application/uploads/2014/12/pdf-sample.pdf",
            "category": "collectibles",
            "type": "doc",
            "price": [],
            "symbol": null,
            "attrs": [
                {
                    "name": "testing pdf",
                    "val": "https://staging-mintpad.vantr.io/",
                    "disp_type": "string",
                    "disp_val": null
                }
            ],
            "media": [
                {
                    "type": "video/mp4",
                    "src": "https://assetgateway.vantr.io/ipfs/QmZ3it8bAJSMfgrAu7RK5uocpnXBGYv3gZnSjqaxnuos6D",
                    "thumbnail": null
                }
            ],
            "digitalTwin": "Yes",
            "nftProvenance": [
                {
                    "title": "Listed By",
                    "from": {
                        "name": "madi@2002",
                        "address": "0x48190057e18c2698f1d340383a29a3000085b7cb",
                        "link": "/ madi@2002 ",
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x48190057e18c2698f1d340383a29a3000085b7cb "
                    },
                    "to": null,
                    "tx_proof": null,
                    "date": "Fri, Jul 1, 2022 5:25 AM GMT",
                    "meta": {
                        "store": "Vantr Marketplace"
                    }
                },
                {
                    "title": "Minted By",
                    "from": {
                        "name": "madi@2002",
                        "address": "0x48190057e18c2698f1d340383a29a3000085b7cb",
                        "link": "/ madi@2002 ",
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x48190057e18c2698f1d340383a29a3000085b7cb "
                    },
                    "to": {
                        "name": "madi@2002",
                        "link": "/ madi@2002 ",
                        "address": "0x48190057e18c2698f1d340383a29a3000085b7cb",
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x48190057e18c2698f1d340383a29a3000085b7cb "
                    },
                    "tx_proof": "https://mumbai.polygonscan.com/tx/0x9a9c123c79541182d2564f282bc7715785497b02d4501aa8a48dc991a97f16a1",
                    "date": "Fri, Jul 1, 2022 5:23 AM GMT",
                    "meta": null
                },
                {
                    "title": "Created By",
                    "from": {
                        "name": "madi@2002",
                        "address": "0x48190057e18c2698f1d340383a29a3000085b7cb",
                        "link": "/ madi@2002 ",
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x48190057e18c2698f1d340383a29a3000085b7cb "
                    },
                    "to": null,
                    "tx_proof": null,
                    "date": "Fri, Jul 1, 2022 5:23 AM GMT",
                    "meta": null
                }
            ],
            "networkType": "polygon",
            "chainId": "80001",
            "hasProvenance": false,
            "creator": {
                "name": "madi@2002",
                "link": "/ madi@2002 ",
                "address": "0x48190057e18c2698f1d340383a29a3000085b7cb",
                "authProofUrl": "https://mumbai.polygonscan.com/address/0x48190057e18c2698f1d340383a29a3000085b7cb ",
                "email": "madindaranm@gmail.com"
            },
            "owner": {
                "name": "madi@2002",
                "link": "/ madi@2002 ",
                "address": "0x48190057e18c2698f1d340383a29a3000085b7cb",
                "authProofUrl": "https://mumbai.polygonscan.com/address/0x48190057e18c2698f1d340383a29a3000085b7cb ",
                "email": "madindaranm@gmail.com"
            },
            "claimEnabled": false,
            "tx_proof": "https://mumbai.polygonscan.com/tx/0x9a9c123c79541182d2564f282bc7715785497b02d4501aa8a48dc991a97f16a1",
            "toBeClaimedBy": {
                "claimType": null
            }
        },
        "viewInIpfs": "https://assetgateway.vantr.io/ipfs/QmXqdfZA6LzVrVybPme96yh2ZKdxKAGRa5ZqWhpXGhwcr3"
    }
    // {
    //     idx: "1",
    //     title: "Federal Reserve Note ",
    //     subtitle: "Very scarce replacement note.Minor tear in bottom margin and small ink spot near the portrait.",
    //     serialNo: 'Rare #/1800',
    //     img: "https://i.ibb.co/9THBcbT/1.jpg",
    //     tag: 'DIAMOND',
    //     productCategory: 'collectibles',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ],
    //     meta: [
    //         {
    //             key: "Year",
    //             value: "1974"
    //         },
    //         {
    //             key: "Denomination",
    //             value: "$50"
    //         },
    //         {
    //             key: "Catalog",
    //             value: "J00295254"
    //         },
    //         {
    //             key: "Plate Position",
    //             value: "D"
    //         },
    //         {
    //             key: "Grade",
    //             value: "35"
    //         }
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         // {
    //         //     type: '3D',
    //         //     thumbnail: Image_3D,
    //         //     original: Image_3D,
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb",
    //         //     src:"https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.glb?1542147958948",
    //         //     iosSrc:"https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.usdz?v=1569545377878",
    //         //     poster:"https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b%2Fposter-astronaut.png?v=1599079951717",
    //         //     shadowIntensity:"1",
    //         //     autoRotateAr:true,
    //         //     cameraControls:true
    //         // },
    //         {
    //             original: SOUND,
    //             thumbnail: SOUND,
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             type: "audio",
    //             embedUrl: 'https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3'
    //         },
    //         // {
    //         //     original:"https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //         //     thumbnail:"https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb",
    //         //     embedUrl: 'https://www.youtube.com/embed/D69igppLEjw?autoplay=1&showinfo=0'
    //         // },
    //         // {
    //         //     original: 'https://i.ibb.co/9THBcbT/1.jpg',
    //         //     thumbnail: 'https://i.ibb.co/9THBcbT/1.jpg',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb",
    //         // },
    //         // {
    //         //     original: 'https://i.ibb.co/9THBcbT/1.jpg',
    //         //     thumbnail: 'https://i.ibb.co/9THBcbT/1.jpg',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // }
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "2",
    //     title: "Casablanca",
    //     subtitle: "During WWII, Rick, a nightclub owner in Casablanca, agrees to help his former lover Ilsa and her husband. Soon, Ilsa's feelings for Rick resurface and she finds herself renewing her love for him.",
    //     serialNo: 'Rare #/1801',
    //     img: "https://i.ibb.co/NKMBMBy/2.jpg",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     scAddress:"0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1",
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 432.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     meta: [
    //         { key: 'Language', value: 'English' },
    //         { key: 'Date', value: '26 November 1942' },
    //         { key: 'Directed by', value: '	Michael Curtiz' },
    //         { key: 'Starring', value: '	Humphrey Bogart, Ingrid Bergman, Paul Henreid, Claude Rains, Conrad Veidt, Sydney GreenstreetPeter, Lorre' },
    //         { key: 'Production company', value: '	Warner Bros. Pictures' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/F5Fty7S/5.png',
    //             thumbnail: 'https://i.ibb.co/F5Fty7S/5.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/wwz1rBJ/1.png',
    //             thumbnail: 'https://i.ibb.co/wwz1rBJ/1.png"',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/68KfTXc/casablanca-1.png',
    //             thumbnail: 'https://i.ibb.co/68KfTXc/casablanca-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "34",
    //     title: "STAR_WARS",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1101',
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 432.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     meta: [
    //         { key: 'Language', value: 'English' },
    //         { key: 'Writer', value: 'George Lucas' },
    //         { key: 'Directed by', value: 'George Lucas' },
    //         { key: 'Starring', value: 'Stars Mark HamillHarrison FordCarrie Fisher' },
    //         { key: 'Motion Picture Rating (MPAA)', value: ' Rated PG for sci-fi violence and brief mild language' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/kBM50wQ/star-wars-1.png',
    //             thumbnail: 'https://i.ibb.co/kBM50wQ/star-wars-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         // {
    //         //     original: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //         //     thumbnail: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //         // {
    //         //     original: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnail: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    // },
    // {
    //     idx: "16",
    //     title: "K. Srikkanth Cover Drive",
    //     subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
    //     serialNo: 'Rare #/1251',
    //     img: "https://i.ibb.co/JmLxbXt/ssrikanth-2.png",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.55
    //         }
    //     ],
    //     meta: [
    //         { key: 'Date of Birth', value: 'December 21, 1959,' },
    //         { key: 'Batting Style', value: 'Right hand bat' },
    //         { key: 'Bowling Style', value: 'Right arm offbreak' },
    //         { key: 'Most catches in an innings', value: '5' },
    //         { key: 'Span', value: '1978/79 - 1992/93' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         // {
    //         //     original: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //         //     thumbnail: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //         {
    //             original: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //             thumbnail: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         // {
    //         //     original: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnail: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         }
    //     ],
    // },
    // {
    //     idx: "15",
    //     title: "Krishnamachari Srikkanth",
    //     subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
    //     serialNo: 'Rare #/1250',
    //     img: "https://i.ibb.co/FVKL72x/ssrikanth-1.png",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.6900
    //         }
    //     ],
    //     meta: [
    //         { key: 'Date of Birth', value: 'December 21, 1959,' },
    //         { key: 'Batting Style', value: 'Right hand bat' },
    //         { key: 'Bowling Style', value: 'Right arm offbreak' },
    //         { key: 'Most catches in an innings', value: '5' },
    //         { key: 'Span', value: '1978/79 - 1992/93' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/WnL4Pt0/dhoni-5.jpg',
    //             thumbnail: 'https://i.ibb.co/WnL4Pt0/dhoni-5.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/YTh22Jn/dhoni-4.jpg',
    //             thumbnail: 'https://i.ibb.co/YTh22Jn/dhoni-4.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/FK2XzmQ/dhoni-3.jpg',
    //             thumbnail: 'https://i.ibb.co/FK2XzmQ/dhoni-3.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         // {
    //         //     original: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //         //     thumbnail: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //         // {
    //         //     original: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnail: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         }
    //     ],
        
    // },
    // {
    //     idx: "16",
    //     title: "K. Srikkanth Cover Drive",
    //     subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
    //     serialNo: 'Rare #/1251',
    //     img: "https://i.ibb.co/JmLxbXt/ssrikanth-2.png",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.55
    //         }
    //     ],
    //     meta: [
    //         { key: 'Date of Birth', value: 'December 21, 1959,' },
    //         { key: 'Batting Style', value: 'Right hand bat' },
    //         { key: 'Bowling Style', value: 'Right arm offbreak' },
    //         { key: 'Most catches in an innings', value: '5' },
    //         { key: 'Span', value: '1978/79 - 1992/93' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         // {
    //         //     original: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //         //     thumbnail: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //         {
    //             original: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //             thumbnail: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         // {
    //         //     original: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnail: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         }
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     }
    // },
    // {
    //     idx: "3",
    //     title: "MS Dhoni",
    //     subtitle: "With a mature head on his shoulders and an astute and shrewd cricketing mind, Dhoni was recommended by senior players like Sachin Tendulkar and Rahul Dravid for captaincy after Rahul Dravid stepped down as skipper",
    //     serialNo: 'Rare #/1802',
    //     img: "https://i.ibb.co/smtvcrt/3.jpg",
    //     tag: 'PLATINUM',
    //     productCategory: 'collectibles',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5123
    //         }
    //     ],
    //     meta: [
    //         { key: 'Against', value: 'Sri Lanka' },
    //         { key: 'Date', value: '02 April 2011' },
    //         { key: 'Player of the match', value: 'MS Dhoni' },
    //         { key: 'Result', value: 'India won by 6 wickets (with 10 balls remaining)' },
    //         { key: 'Location', value: 'Wankhede Stadium Mumbai' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/WnL4Pt0/dhoni-5.jpg',
    //             thumbnail: 'https://i.ibb.co/WnL4Pt0/dhoni-5.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/YTh22Jn/dhoni-4.jpg',
    //             thumbnail: 'https://i.ibb.co/YTh22Jn/dhoni-4.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/FK2XzmQ/dhoni-3.jpg',
    //             thumbnail: 'https://i.ibb.co/FK2XzmQ/dhoni-3.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "4",
    //     title: "AB De Villiers",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1201',
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 432.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     meta: [
    //         { key: 'Born', value: 'February 17, 1984, Pretoria' },
    //         { key: 'Batting', value: 'Right hand bat' },
    //         { key: 'Bowling', value: 'Right arm medium' },
    //         { key: 'Role', value: 'Wicketkeeper batter' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnail: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnail: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "31",
    //     title: "Joe Root",
    //     subtitle: "Joe Root, born on 30th December 1990, hails from a rich cricketing background. His grandfather captained Rotherham CC in the Yorkshire League for several seasons whilst his younger brother,",
    //     serialNo: 'Rare #/1202',
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 859.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     meta: [
    //         { key: 'Born', value: 'Dec 30, 1990 (30 years)' },
    //         { key: 'Batting', value: 'Right Handed Bat' },
    //         { key: 'Bowling', value: 'Right-arm offbreak' },
    //         { key: 'Role', value: 'Batter' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnail: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnail: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "32",
    //     title: "Ricky Ponting",
    //     subtitle: "Ricky Ponting had all the ingredients of a typical Australian - tough as nails, aggressive, vocal and above all, mentally powerful to tackle pressure situations. ",
    //     serialNo: 'Rare #/1203',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 52.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     meta: [
    //         { key: 'Born', value: 'Dec 19, 1974 (46 years)' },
    //         { key: 'Batting', value: 'Right Handed Bat' },
    //         { key: 'Bowling', value: 'Right-arm offbreak' },
    //         { key: 'Role', value: 'Batter' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnail: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnail: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "33",
    //     title: "David Warner",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1204',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 52.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     meta: [
    //         { key: 'Born', value: 'October 27, 1986, Paddington, New South Wales' },
    //         { key: 'Batting', value: 'Left hand bat' },
    //         { key: 'Bowling', value: 'Legbreak' },
    //         { key: 'Role', value: 'Opening batter' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnail: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnail: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "5",
    //     title: "1979 Worldcup Team",
    //     subtitle: "The 1979 Cricket World Cup was the second edition of the Cricket World Cup. Organised by the International Cricket Conference",
    //     serialNo: 'Rare #/1300',
    //     img: "https://i.ibb.co/PF00MG1/cricket-world-cup.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 3000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1.02
    //         }
    //     ],
    //     meta: [
    //         { key: 'Against', value: 'England' },
    //         { key: 'Date', value: 'Jun 23 1979' },
    //         { key: 'Player of the match', value: 'Viv Richards' },
    //         { key: 'Result', value: 'West Indies won by 92 runs' },
    //         { key: 'Location', value: 'Lord\'s, London' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/PF00MG1/cricket-world-cup.png',
    //             thumbnail: 'https://i.ibb.co/PF00MG1/cricket-world-cup.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/yg9pTBg/cricket-world-cup-2.png',
    //             thumbnail: 'https://i.ibb.co/yg9pTBg/cricket-world-cup-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "7",
    //     title: "Brian Lara\'s Era",
    //     subtitle: "A hero, a magician, an entertainer, a match-winner, a saviour, a leader, a tragic romantic, Brian Charles Lara, like a masterful actor, slipped in and out of several roles with effortless ease. First thing's first, Lara will forever be remembered as one of the greatest batsmen of the modern era, bracketed alongside the elite company of Sachin Tendulkar, Ricky Ponting and Jacques Kallis.",
    //     serialNo: 'Rare #/1302',
    //     img: "https://i.ibb.co/gmgjYxP/brian-lara-era.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     networkType:'ethereum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 6000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 2.04
    //         }
    //     ],
    //     meta: [
    //         { key: 'Born', value: 'May 02, 1969 (52 years)' },
    //         { key: 'Birth Place', value: 'Cantaro, Santa Cruz, Trinidad' },
    //         { key: 'Height', value: '5 ft 8 in' },
    //         { key: 'Role', value: 'Batsman' },
    //         { key: 'Batting Style', value: 'Left Handed Bat' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnail: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnail: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "6",
    //     title: "Virat Kohli\'s Lamborghini",
    //     subtitle: "A swanky Lamborghini used by Virat Kohli up for sale, and has run only 10000 km till date.",
    //     serialNo: 'Rare #/1301',
    //     img: "https://i.ibb.co/yYgM4JD/virat-lamb-1.png",
    //     tag: 'PLATINUM',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     networkType:'polygon',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 8000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 2.72
    //         }
    //     ],
    //     meta: [
    //         { key: 'Started Year', value: '1896' },
    //         { key: 'Place', value: 'Port of Spain, Trinidad and Tobago' },
    //         { key: 'Includes', value: 'Main cricket stadium' },
    //         { key: 'Includes', value: 'Members gym' },
    //         { key: 'Includes', value: 'indoor and outdoor cricket practice nets' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnail: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnail: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "9",
    //     title: "Brian Lara\'s Test Hundreds",
    //     subtitle: "Brian Charles Lara, TC, OCC, AM is a Trinidadian former international cricketer, widely acknowledged as one of the greatest batsmen of all time.",
    //     serialNo: 'Rare #/1304',
    //     img: "https://i.ibb.co/R6kZyDC/lara-hundreds.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 9000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 3.10
    //         }
    //     ],
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //         { key: 'Highest Score', value: '400*' },
    //         { key: 'Average', value: '53.17' },
    //         { key: 'Hundreds', value: '34' },
    //         { key: 'Fifties', value: '48' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnail: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             src: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.glb?1542147958948",
    //             iosSrc: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.usdz?v=1569545377878",
    //             poster: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b%2Fposter-astronaut.png?v=1599079951717",
    //             shadowIntensity: "1",
    //             autoRotateAr: true,
    //             cameraControls: true
    //         }
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "10",
    //     title: "QPCC Cricket Museum",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1305',
    //     img: "https://i.ibb.co/FJ5KXYY/museum.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //             thumbnail: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             embedUrl: 'https://www.youtube.com/embed/D69igppLEjw?autoplay=1&showinfo=0'
    //         }
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "11",
    //     title: "QPCC Cricket Museum",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1306',
    //     img: "https://i.ibb.co/dJc6sjY/signature.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //     ],
    //     buttons: [
    //         {
    //             original: 'https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg',
    //             thumbnail: 'https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/G5t1Gnc/Bermuda-P23a-R-0212691.jpg',
    //             thumbnail: 'https://i.ibb.co/G5t1Gnc/Bermuda-P23a-R-0212691.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnail: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnail: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "12",
    //     title: "QPCC",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1307',
    //     img: "https://i.ibb.co/cX2PD5d/sout-africa.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnail: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnail: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },

    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "6",
    //     title: "Virat Kohli\'s Lamborghini",
    //     subtitle: "A swanky Lamborghini used by Virat Kohli up for sale, and has run only 10000 km till date.",
    //     serialNo: 'Rare #/1301',
    //     img: "https://i.ibb.co/yYgM4JD/virat-lamb-1.png",
    //     tag: 'PLATINUM',
    //     productCategory: 'collectibles',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 182766.09
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 62.04
    //         }
    //     ],
    //     meta: [
    //         { key: 'Model', value: '2015' },
    //         { key: 'Can reach', value: '0 to 100 km/h in just 4 seconds' },
    //         { key: 'KMs Driven', value: '10000' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/yYgM4JD/virat-lamb-1.png',
    //             thumbnail: 'https://i.ibb.co/yYgM4JD/virat-lamb-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/F6nvpRn/virat-lamb-2.png',
    //             thumbnail: 'https://i.ibb.co/F6nvpRn/virat-lamb-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "491",
    //     title: "Federal Reserve Note ",
    //     subtitle: "Very scarce replacement note.Minor tear in bottom margin and small ink spot near the portrait.",
    //     serialNo: 'Rare #/1800',
    //     img: "https://i.ibb.co/9THBcbT/1.jpg",
    //     tag: 'DIAMOND',
    //     productCategory: 'collectibles',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ],
    //     meta: [
    //         {
    //             key: "Year",
    //             value: "1974"
    //         },
    //         {
    //             key: "Denomination",
    //             value: "$50"
    //         },
    //         {
    //             key: "Catalog",
    //             value: "J00295254"
    //         },
    //         {
    //             key: "Plate Position",
    //             value: "D"
    //         },
    //         {
    //             key: "Grade",
    //             value: "35"
    //         }
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             type: '3D',
    //             thumbnail: Image_3D,
    //             original: Image_3D,
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             src: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.glb?1542147958948",
    //             iosSrc: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.usdz?v=1569545377878",
    //             poster: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b%2Fposter-astronaut.png?v=1599079951717",
    //             shadowIntensity: "1",
    //             autoRotateAr: true,
    //             cameraControls: true
    //         }
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         }
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "492",
    //     title: "Federal Reserve Note ",
    //     subtitle: "Very scarce replacement note.Minor tear in bottom margin and small ink spot near the portrait.",
    //     serialNo: 'Rare #/1800',
    //     img: "https://i.ibb.co/9THBcbT/1.jpg",
    //     tag: 'DIAMOND',
    //     productCategory: 'collectibles',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ],
    //     meta: [
    //         {
    //             key: "Year",
    //             value: "1974"
    //         },
    //         {
    //             key: "Denomination",
    //             value: "$50"
    //         },
    //         {
    //             key: "Catalog",
    //             value: "J00295254"
    //         },
    //         {
    //             key: "Plate Position",
    //             value: "D"
    //         },
    //         {
    //             key: "Grade",
    //             value: "35"
    //         }
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //             thumbnail: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             embedUrl: 'https://www.youtube.com/embed/D69igppLEjw?autoplay=1&showinfo=0'
    //         }
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         }
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },
            
    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },
        
    // },
    // {
    //     idx: "21",
    //     title: "Bermuda P23A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/23a',
    //     img: "https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     networkType:'polygon',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'MATIC',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '561' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '1' },
    //         { key: 'Pick #', value: '23a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     buttons: [
    //         {
    //             key: "claim",
    //             title: "CLAIM"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg',
    //             thumbnail: 'https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/G5t1Gnc/Bermuda-P23a-R-0212691.jpg',
    //             thumbnail: 'https://i.ibb.co/G5t1Gnc/Bermuda-P23a-R-0212691.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "22",
    //     title: "Bermuda-P24A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/24a',
    //     img: "https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     networkType:'ethereum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '562' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '5' },
    //         { key: 'Pick #', value: '24a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg',
    //             thumbnail: 'https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/gmx1B2k/Bermuda-P24a-R-0212692.jpg',
    //             thumbnail: 'https://i.ibb.co/gmx1B2k/Bermuda-P24a-R-0212692.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "23",
    //     title: "Bermuda P25A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/25a',
    //     img: "https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 4272.45
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '563' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '10' },
    //         { key: 'Pick #', value: '25a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg',
    //             thumbnail: 'https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/T8P641T/Bermuda-P25a-R-0212693.jpg',
    //             thumbnail: 'https://i.ibb.co/T8P641T/Bermuda-P25a-R-0212693.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "24",
    //     title: "Bermuda P26A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/26a',
    //     img: "https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '564' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '20' },
    //         { key: 'Pick #', value: '26a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg',
    //             thumbnail: 'https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/f9NkmBG/Bermuda-P26a-R-0212694.jpg',
    //             thumbnail: 'https://i.ibb.co/f9NkmBG/Bermuda-P26a-R-0212694.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "25",
    //     title: "Bermuda P32B Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/32b',
    //     img: "https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 4272.45
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '1120' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1974' },
    //         { key: 'Denomination', value: '50' },
    //         { key: 'Pick #', value: '32b' },
    //         { key: 'Grade', value: 'VF' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 465860' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg',
    //             thumbnail: 'https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/cXD9R7S/Bermuda-P32b-R-0212695.jpg',
    //             thumbnail: 'https://i.ibb.co/cXD9R7S/Bermuda-P32b-R-0212695.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "26",
    //     title: "Bermuda P33C Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/33c',
    //     img: "https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '1547' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1986' },
    //         { key: 'Denomination', value: '100' },
    //         { key: 'Pick #', value: '33c' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 200021' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg',
    //             thumbnail: 'https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/xHQ2sVW/Bermuda-P33c-R-0212696.jpg',
    //             thumbnail: 'https://i.ibb.co/xHQ2sVW/Bermuda-P33c-R-0212696.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "27",
    //     title: "British Caribbean Terr. P-6",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/P6',
    //     img: "https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy:{
    //         title:"",
    //         name:"Lyn Knight Auction",
    //         link:"lyn-knight-auction"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '009845' },
    //         { key: 'Country', value: 'British Caribbean Terr.' },
    //         { key: 'Year', value: '1950' },
    //         { key: 'Denomination', value: '100 Dollars' },
    //         { key: 'Sig', value: 'Robertson / McDavid  / Cuke' },
    //         { key: 'Pick #', value: 'P-6' },
    //         { key: 'Grade', value: 'Very Fine' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 009845' },
    //         { key: 'Printer', value: 'BWC' },
    //         { key: 'Theme', value: 'KGV1,map / 4 different arms' },
    //     ],
    //     buttons: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg',
    //             thumbnail: 'https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/JKRjLC0/Optimized-P6-Rear.jpg',
    //             thumbnail: 'https://i.ibb.co/JKRjLC0/Optimized-P6-Rear.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },
    // {
    //     idx: "28",
    //     title: "Hemakuta",
    //     subtitle: ["According to Indian history, this is the hill that Lord Siva did penance before marrying a local girl Pampa. Siva was impressed by her dedication for him and consent to marry her. Due to this decision of Lord Shiva it rained gold on the hill. Since gold is known as Hema in Sanskrit, this hill came to be known as Hemakuta.", "Another legend has it that Hemakuta Hill was also the place where Lord Shiva had burnt Kama, the God of lust. Kama had helped Pampa to marry Shiva by distracting Shiva from his penance. This act of Kama angered Shiva and he killed Kama by emitting fire from his third eye. However, after Kama's wife Rathi pleaded with Shiva for the life of her husband, Shiva relented. Shiva brought back Kama to life but only in character and not as a physical being."],
    //     serialNo: 'Rare #/P28',
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     // price: [
    //     //     {
    //     //         type: 'fiat',
    //     //         currency: 'USD',
    //     //         locale: 'en-US',
    //     //         amount: 25000
    //     //     },
    //     //     {
    //     //         type: 'crypto',
    //     //         currency: 'ETH',
    //     //         amount: 5.29
    //     //     }
    //     // ],
    //     // buttons: [
    //     //     {
    //     //         key: "buyNowFiat",
    //     //         title: "Buy in USD"
    //     //     },
    //     //     {
    //     //         key: "buyNowCrypto",
    //     //         title: "Buy in ETH"
    //     //     }
    //     // ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg',
    //             thumbnail: 'https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/xHQ2sVW/Bermuda-P33c-R-0212696.jpg',
    //             thumbnail: 'https://i.ibb.co/xHQ2sVW/Bermuda-P33c-R-0212696.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     timeline: [
    //         {
    //             title: "Asset Listed",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Listed At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of List",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Minted",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Minted At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Mint",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Asset Created",
    //             description: [
    //                 {
    //                     displayType: "date",
    //                     key: "Created At",
    //                     value: new Date().toISOString()
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "From",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "To",
    //                     value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
    //                     link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    //                 },
    //                 {
    //                     displayType: "link",
    //                     key: "Proof of Creation",
    //                     value: "Proof on Rinkeby",
    //                     link: "https://rinkeby.etherscan.io"
    //                 }
    //             ]
    //         },
    //     ],
        
    // },  
]


export const MY_DETAIL = 
    {
        "getMyAsset": {
            "pdfDetail":true,
            "title": "lorem san",
            "subtitle": "<p>dzfdhgfhghgutyugjhteyuj9e8ouifyujehghj</p>",
            "serialNo": "1468",
            "tokenGroup": "uD8sZ",
            "tag": "platinum",
            "type": "doc",
            "img": "https://www.africau.edu/images/default/sample.pdf",
            "thumbnail": "https://assetgateway.vantr.io/ipfs/Qmc2XMoTokoUyXe9FtzDhBXZ9guTvVKFMUdN4wd27anReg",
            "category": "art",
            "price": [
                {
                    "amount": 0.0101,
                    "type": "crypto",
                    "currency": "MATIC",
                    "sale": null,
                    "symbol": "Matic"
                }
            ],
            "symbol": null,
            "attrs": [],
            "media": [],
            "digitalTwin": "Yes",
            "claimEnabled": false,
            "owner": {
                "name": null,
                "link": null,
                "address": "0xd1d12a39cf1e8420196c051e04aa5ebf9680e03a",
                "authProofUrl": "https://mumbai.polygonscan.com/address/0xd1d12a39cf1e8420196c051e04aa5ebf9680e03a"
            },
            "nftProvenance": [
                {
                    "title": "Created On",
                    "from": {
                        "address": "0x3923ecf65166fea021d48305d7b41c1caa52fd61",
                        "link": null,
                        "name": null,
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x3923ecf65166fea021d48305d7b41c1caa52fd61"
                    },
                    "to": null,
                    "date": "2022-09-28T11:32:08.559Z",
                    "meta": {}
                },
                {
                    "title": "Minted On",
                    "from": {
                        "address": "0x3923ecf65166fea021d48305d7b41c1caa52fd61",
                        "link": null,
                        "name": null,
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x3923ecf65166fea021d48305d7b41c1caa52fd61"
                    },
                    "to": {
                        "name": null,
                        "link": null,
                        "address": "0x3923ecf65166fea021d48305d7b41c1caa52fd61",
                        "authProofUrl": "https://mumbai.polygonscan.com/address/0x3923ecf65166fea021d48305d7b41c1caa52fd61"
                    },
                    "date": "2022-09-28T11:49:43.000Z",
                    "meta": {}
                }
            ],
            "networkType": "polygon",
            "state": "sold",
            "chainId": "80001",
            "hasProvenance": false,
            "assetAuthProof": "https://mumbai.polygonscan.com/tx/0x1821bdefff39ea9c4c9562e1e767830f800c8a282f565bf38f3f5480150b25b2",
            "creator": {
                "name": null,
                "link": null,
                "address": "0x3923ecf65166fea021d48305d7b41c1caa52fd61",
                "authProofUrl": "https://mumbai.polygonscan.com/address/0x3923ecf65166fea021d48305d7b41c1caa52fd61"
            },
            "receipt": [
                {
                    "key": "Transaction ID",
                    "value": "tx_33mMq35"
                },
                {
                    "key": "Asset Name",
                    "value": "lorem ispium"
                },
                {
                    "key": "Asset Creator",
                    "value": "0x3923ecf65166fea021d48305d7b41c1caa52fd61"
                },
                {
                    "key": "Purchase Date",
                    "value": "2022-09-28T11:49:43.000Z"
                },
                {
                    "key": "Purchase Price",
                    "value": "0.01"
                },
                {
                    "key": "NFT Transfer Address",
                    "value": "0xd1d12a39cf1e8420196c051e04aa5ebf9680e03a"
                }
            ]
        }
    }


export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
            { label: "Crypto", value: "Crypto" },
            { label: "Stocks", value: "Stocks", disabled: true },
            { label: "Gold", value: "Gold" },
            { label: "NFT", value: "NFT" },
        ]
    },
    {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
            { label: "India", value: "Ind" },
            { label: "U.S.A.", value: "usa" },
            { label: "China", value: "china" },
            { label: "Pakistan", value: "pak", disabled: true },
            { label: "Russia", value: "rus" },
            { label: "Italy", value: "Italy" },
        ]
    },
    {
        type: "checkbox",
        title: "Categories",
        key: "id-5",
        categories: [
            { label: "Music", value: "Music" },
            { label: "Cricket", value: "Cricket" },
            { label: "Football", value: "Football" },
            { label: "Art", value: "Art" },
            { label: "Movies", value: "Movies" },
            { label: "Cars", value: "Cars" },
            { label: "Travel", value: "Travel" },
            { label: "Fashion", value: "Fashion", disabled: true },
            { label: "Food", value: "Food" },
            { label: "Country", value: "County" },
            { label: "Plants", value: "Plants" },
            { label: "Science", value: "Science" }
        ]
    },
    {
        type: "checkbox",
        title: "Time period",
        key: "id-6",
        categories: [
            { label: "2001-2004", value: "2001-2004" },
            { label: "2005-2008", value: "2005-2008" },
            { label: "2009-2012", value: "2009-2012" },
            { label: "2013-2016", value: "2013-2016" },
            { label: "2017-2020", value: "2017-2020", disabled: true },
            { label: "2021", value: "2021" },
        ]
    },
    {
        type: "range",
        title: "Price",
        key: "id-9",
        min: 0,
        max: 200,
        default: "ETH",
        subCategoriesTitle: "Currency",
        categories: [
            { label: "buyNowFiat", value: "buyNowFiat", disabled: true },
            { label: "Ethereum", value: "ETH" },
            { label: "Indian Rupee", value: "INR" }
        ]
    }
];

export const TIMELINE_TABLE_HEADER = [
    {
        type: 'default',
        compProps: {
            headerName: 'Event',
            field: 'event',
            filter: 'agTextColumnFilter',
            minWidth: 70,
        },
        valueStyle: { color: '#1a4677' },
    },
    {
        type: 'currency',
        compProps: {
            headerName: 'Price',
            field: 'price',
            filter: 'agNumberColumnFilter',
            minWidth: 70,
        },
        valueStyle: { color: '#1a4677' },
    },
    {
        type: 'anchor',
        compProps: {
            headerName: 'From',
            field: 'from',
            filter: 'agTextColumnFilter',
            minWidth: 250,
        },
        valueStyle: { color: '#1a4677' },
    },
    {
        type: 'anchor',
        compProps: {
            headerName: 'To',
            field: 'to',
            filter: 'agTextColumnFilter',
            minWidth: 250,
        },
        valueStyle: { color: '#1a4677' },
    },
    {
        type: 'default',
        compProps: {
            headerName: 'Date',
            field: 'date',
            filter: 'agDateColumnFilter',
            minWidth: 120,
        },
        valueStyle: { color: '#1a4677' },
    },

];

export const GRID_OPTIONS = {
    pagination: false,
    rowHeight: 85,
    defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        unSortIcon: true,
    },
};

export const ownership =[
    {
        title:"View on IPFS",
        link:"https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a"
    }
]
